var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJenkinsSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_jenkins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.513,25.173c-.068,0-.136,0-.2-.01C19.378,25.169,19.445,25.173,19.513,25.173Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.919,25.087a1.93,1.93,0,0,0,.392.076A1.93,1.93,0,0,1,18.919,25.087Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.091,27.511c-.021-.121-.043-.221-.064-.31h0c.021.089.043.189.064.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.436,14.214A.832.832,0,0,1,7.6,14.1.581.581,0,0,0,7.436,14.214Z",
    style: {
      fill: "#f0d6b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.412,18.253c.06.421.24,4.164,2.766,6.25a15.465,15.465,0,0,0,1.549.162c.28-.6,1.312-.554,1.985-.4a6.648,6.648,0,0,1-2.176-1.778,4.466,4.466,0,0,1-1.472-2.656c1.348,1.87,2.462,3.5,4.913,4.326,1.855.622,4.021-.285,5.446-1.286a6.258,6.258,0,0,0,1.365-1.68,14.242,14.242,0,0,0,2.145-8.621,9.567,9.567,0,0,0-.5-3.446c-.453-.908-1.984-1.72-2.88-.9a1.07,1.07,0,0,1-.016-.246c-.143.134-.23.232-.23.232a1.209,1.209,0,0,1-.122-.487,1.551,1.551,0,0,1,1.5-1.5,8.674,8.674,0,0,0-1.479-1.563,10.49,10.49,0,0,0-6.047-.222,8.06,8.06,0,0,0-5.975,5.4,14.085,14.085,0,0,0-.388,2.263c-.031.884.416,1.655.45,2.617-.239.394-.969.443-1.474.416-.037-.187-.082-.379-.136-.566a5.158,5.158,0,0,0-1.265-.5,1.719,1.719,0,0,1,1.009,2.038c-.373-.213-.462-1.15-.9-1.177-.626-.038-.512,1.216-.509,1.95a2.291,2.291,0,0,1-.19-2.213c-.284-.139-.444.061-.6.217-.222,1.036-.547,1.873.062,2.92a1.734,1.734,0,0,0,1.414.6c.567-.056.706-.624,1.324-.618A.513.513,0,0,1,10.412,18.253ZM16.861,20.2l-.3-.061s-.314-1.1-.163-1.306c.08-.107.52-.268,1.136.028C17.53,18.862,16.8,18.984,16.861,20.2Zm5.706,1.341a5.27,5.27,0,0,1-3.426-.014A4.687,4.687,0,0,1,17.858,20.1c-.155-.2-.927-.708-.012-.709h0c.717,1.8,3.18,1.592,5.257,1.543A1.111,1.111,0,0,1,22.567,21.542Zm.3-1.6a4.016,4.016,0,0,1,0-1.063,8.538,8.538,0,0,0,2.96-1.185h0A3.425,3.425,0,0,1,22.866,19.939Zm2.756-8.073c-.183.061-1.37.762-1.278-.122a1.348,1.348,0,0,1,1.026-1.077,3.037,3.037,0,0,1,0-.4h0l.079,0a17.146,17.146,0,0,0,1.172,2.29c-.317.738-2.4,1.39-2.366.066.45-.2,1.227-.04,1.626-.291-.094-.257-.2-.5-.3-.756Zm-5.187,4.75a.719.719,0,0,1,.046.1c.091-.507.259-1.1.548-1.013a.684.684,0,0,1,.5.638,6.908,6.908,0,0,0-.948.738c.065.3.144.6.523.668,1.106.189,2.393-.677,3.189-.979.493-.832-.043-1.138-.487-1.673-.91-1.1-2.13-2.456-2.086-4.1.368-.267.4.407.452.53a15.006,15.006,0,0,0,2.543,3.486c.214.234.567.459.606.614.113.451-.294.991-.247,1.29h0a6.587,6.587,0,0,1-4.466,1.4A1.322,1.322,0,0,1,20.434,16.615Zm1.958,2.321A4.933,4.933,0,0,1,22.47,20c-1.811.09-3.952-.358-4.427-1.629A10.285,10.285,0,0,0,22.393,18.936Zm-4.256-8.648a6.954,6.954,0,0,0,.977,1.829c.228.222.67.492.451,1.109a1.406,1.406,0,0,1-.642.534c-.79.233-2.631.048-2.008-.937.653.03,1.532.424,2.02-.05-.095-.152-.209-.341-.322-.551-.5.316-1.874.33-1.874-.479,0-.852,1.339-1.034,1.339-1.034l.01.024A1.11,1.11,0,0,1,18.137,10.288ZM14.914,7.363c1.195-.815,1.8-.35,2.1.188a.568.568,0,0,1,.274.828c-1.658-.386-2.482.694-2.985,1.814-.129.234-.136.068-.21-.136a.392.392,0,0,1-.061-.136A.551.551,0,0,0,13.94,9.8C13.7,9.553,13.575,8.276,14.914,7.363Z",
    style: {
      fill: "#f0d6b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.283,29.28h8.753c-.04-.135-.079-.268-.118-.394a12.164,12.164,0,0,1-.476-1.948,21.079,21.079,0,0,1-3.087-1.655,2.353,2.353,0,0,1-.24-.257L5.849,27.379S6.038,28.133,6.283,29.28Z",
    style: {
      fill: "#335061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.433,7A2.125,2.125,0,0,1,9.9,6.912a3.817,3.817,0,0,0,.747.029c.494-.123.912-1.231,1.285-1.644a11.333,11.333,0,0,1,.941-.776A7.346,7.346,0,0,0,9.433,7Z",
    style: {
      fill: "#6d6b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.177,12.586a2.147,2.147,0,0,1,3.145,1.747c.694-.018.259-.866.134-1.413-.369-1.608.487-3.34.192-4.861C6.782,8.637,7,11.606,7.177,12.586Z",
    style: {
      fill: "#6d6b6d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.249,3.851c-1.82.516-4.152,1.838-4.9,3.473A7.389,7.389,0,0,0,9.433,7a7.346,7.346,0,0,1,3.44-2.479,1.647,1.647,0,0,0,.159-.166c.192-.093.476-.086.487-.375C13.436,3.891,13.348,3.823,13.249,3.851Z",
    style: {
      fill: "#dcd9d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,8.985c-.8.885-.636,2.542-.538,3.721a2.321,2.321,0,0,1,.218-.12c-.18-.979-.394-3.949,3.471-4.527a2.81,2.81,0,0,0-.142-.493A4.409,4.409,0,0,0,7.5,8.985Z",
    style: {
      fill: "#dcd9d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.412,18.253a.513.513,0,0,0-.42-.468c.335.668-.516.878-.6,1.355a3.837,3.837,0,0,0,.125.832,11.351,11.351,0,0,0,1.445,3.365,3.181,3.181,0,0,0,2.22,1.166C10.652,22.418,10.472,18.674,10.412,18.253Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525,16.338a.684.684,0,0,0-.5-.638c-.289-.082-.457.506-.548,1.013a2.376,2.376,0,0,1,.1.363A6.908,6.908,0,0,1,21.525,16.338Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.344,11.744c-.092.884,1.1.183,1.278.122l-.043-.286a3.235,3.235,0,0,1-.209-.913A1.348,1.348,0,0,0,24.344,11.744Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.739,11.744c0,.809,1.371.795,1.874.479a4.053,4.053,0,0,1-.525-1.489l-.01-.024S16.739,10.892,16.739,11.744Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192,14.885a.8.8,0,0,1-.125.109,1.221,1.221,0,0,1,.37-.781A.581.581,0,0,1,7.6,14.1a.979.979,0,0,1,.782-.032,5.158,5.158,0,0,1,1.265.5c-.193-.664-.524-1.263-1.208-1.338a2.034,2.034,0,0,0-2.2,1.963A3.858,3.858,0,0,0,7.254,17.8C6.644,16.758,6.97,15.921,7.192,14.885Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.165,4.443a10.49,10.49,0,0,1,6.047.222,4.127,4.127,0,0,0-.49-.329c-1.889-1.066-5.086-1.867-7.1-.866-1.621.808-3.813,2.146-4.56,3.841a4.109,4.109,0,0,1,.123,2.532A8.06,8.06,0,0,1,17.165,4.443Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.188,7.728a1.209,1.209,0,0,0,.122.487s.087-.1.23-.232c.031-.734.865-1.152,1.832-.866-.222-.286-.447-.589-.681-.889A1.551,1.551,0,0,0,23.188,7.728Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.092,10.058c.074.2.082.37.21.136A.348.348,0,0,1,14.092,10.058Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.032,9.922a1.486,1.486,0,0,1,.114-.758,2.816,2.816,0,0,1,2.47-1.755,1.149,1.149,0,0,1,.4.143c-.3-.538-.9-1-2.1-.188-1.338.913-1.217,2.19-.973,2.434A.551.551,0,0,1,14.032,9.922Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.849,27.379l5.266-2.353c-.386-.448-1.079-1.3-1.2-1.257a24.079,24.079,0,0,0-5.61,3.485,20.236,20.236,0,0,1,.81,2.026H6.283C6.038,28.133,5.849,27.379,5.849,27.379Z",
    style: {
      fill: "#49728b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,29.307a20.836,20.836,0,0,0,.548-2.058c.036-.181.106-.475.156-.756l-2.886-2.144a5.123,5.123,0,0,1,.13,3.9c.1.372.454.515.6.85-.034.06-.068.119-.1.179h1.476A.149.149,0,0,1,27,29.307Z",
    style: {
      fill: "#335061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.441,28.074a1.081,1.081,0,0,0,.172-.381,1.081,1.081,0,0,1-.172.381Z",
    style: {
      fill: "#335061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.617,23.946a.948.948,0,0,1,.514-.106l-.238-.177A1.457,1.457,0,0,0,23.617,23.946Z",
    style: {
      fill: "#335061"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.756,25.879c-.074-.537-.8-.935-1.172-1.266C25.9,24,25.472,23.46,24.761,22.887a4.391,4.391,0,0,1-.869.776l.238.177a.932.932,0,0,1,.686.51L27.7,26.493A2.339,2.339,0,0,0,27.756,25.879Z",
    style: {
      fill: "#49728b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.572,29.2a.438.438,0,0,0,.009.076h.479a.333.333,0,0,1,.666,0H22.5v-.03c-.274-.144-.873-.455-1.2-.593C20.876,28.475,20.572,29.2,20.572,29.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.572,29.2s.3-.73.73-.548c.322.138.921.449,1.2.593.01-.22.02-.44.034-.66-.618.039-.961-.559-1.394-.605-.378-.041-.7.435-1.19.229-.113.124-.215.259-.33.381a6.313,6.313,0,0,1,.489.685h.476A.438.438,0,0,1,20.572,29.2Z",
    style: {
      fill: "#dcd9d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.511,25.169a6.738,6.738,0,0,1-2.269-.4.282.282,0,0,0,.017.421,7.657,7.657,0,0,0,2.14.578A1.748,1.748,0,0,0,14.511,25.169Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357,26.069a1.233,1.233,0,0,1,.041-.3,7.657,7.657,0,0,1-2.14-.578A4.237,4.237,0,0,0,14.357,26.069Z",
    style: {
      fill: "#dcd9d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.613,27.693a2.963,2.963,0,0,0,.073-.87,7.057,7.057,0,0,0-.2-1.378,3,3,0,0,0-1.009.049c-.3.061-.609.122-.669.487s.122.548-.061.852-.487.122-.791.3c-.207.124-.076.445.029.638a12.138,12.138,0,0,0,2.459.3A1.081,1.081,0,0,0,24.613,27.693Z",
    style: {
      fill: "#d33833"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.562,29.219c.016.043.033.088.047.128s.029.093.042.139l-.009-.117Z",
    style: {
      fill: "#d33833"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.563,27.925q.01-.264.021-.527a1.309,1.309,0,0,1-.96-.074c-.937-.511-.05-.36-.382-1.038a3.236,3.236,0,0,0-1.224-.365c-1.228,0-1.7-.247-1.568,1.169.069.76.131,1.519.191,2.28.1.188.19.357.262.5a4.834,4.834,0,0,0,1.833-.559A21.007,21.007,0,0,0,19.563,27.925Z",
    style: {
      fill: "#d33833"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.027,27.2c.021.089.043.189.064.31h0a.7.7,0,1,0,.428-1.31A.953.953,0,0,1,20.027,27.2Z",
    style: {
      fill: "#d33833"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.953,27.137c.3-.183.609,0,.791-.3s0-.487.061-.852.365-.426.669-.487a3,3,0,0,1,1.009-.049,1.125,1.125,0,0,0-.348-.652c-.747-.436-2.056.825-2.665,1.093l-.057.023a1.694,1.694,0,0,1,.175.558A1.475,1.475,0,0,1,22,26.429a1.761,1.761,0,0,1,.276.033c.045.009.089.02.133.032a1.463,1.463,0,0,1,.243.092,4.209,4.209,0,0,0-.757.1.7.7,0,0,0-.2.095,8.618,8.618,0,0,0-.035.9q.158.045.322.084C21.877,27.582,21.746,27.261,21.953,27.137Z",
    style: {
      fill: "#ef3d3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.651,29.485c.051.183.095.348.253.385-.072-.144-.163-.313-.262-.5Z",
    style: {
      fill: "#ef3d3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.45,27.089c-.129-1.416.34-1.169,1.568-1.169a3.236,3.236,0,0,1,1.224.365c.332.678-.555.527.382,1.038a1.309,1.309,0,0,0,.96.074l0-.063a3.039,3.039,0,0,0-.916-.29,3.5,3.5,0,0,0-.371-.036,1.555,1.555,0,0,1,.291-.106,3.285,3.285,0,0,0,.906-.281c0-.079.006-.158.009-.236a1.883,1.883,0,0,1-.2-.027,1.565,1.565,0,0,1-.177-.044,1.585,1.585,0,0,1-.294-.127c-.178-.1-.331-.216-.525-.322a9.077,9.077,0,0,0-2.408-.881c-.921-.176-.929,1.105-.89,2.049,0,.1.008.192.013.28a6.585,6.585,0,0,0,.544,1.9l.079.15C15.582,28.609,15.519,27.849,15.45,27.089Z",
    style: {
      fill: "#ef3d3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.52,26.2a1.009,1.009,0,0,0-.582.2,1.7,1.7,0,0,0,.007.412c.011.079.028.155.048.238l.031.131,0,.017h0A.953.953,0,0,0,20.52,26.2Z",
    style: {
      fill: "#ef3d3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.146,9.164a1.486,1.486,0,0,0-.114.758.392.392,0,0,0,.061.136.348.348,0,0,0,.21.136c.5-1.12,1.327-2.2,2.985-1.814a.568.568,0,0,0-.274-.828,1.149,1.149,0,0,0-.4-.143A2.816,2.816,0,0,0,14.146,9.164Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.252,12.627c-.032,1.324,2.049.672,2.366-.066a17.146,17.146,0,0,1-1.172-2.29l-.079,0h0a3.037,3.037,0,0,0,0,.4,3.235,3.235,0,0,0,.209.913c.095.256.205.5.3.756C25.479,12.587,24.7,12.43,24.252,12.627Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.934,12.773c-.488.474-1.367.08-2.02.05-.623.985,1.218,1.17,2.008.937a1.406,1.406,0,0,0,.642-.534c.219-.617-.223-.887-.451-1.109a6.954,6.954,0,0,1-.977-1.829,1.11,1.11,0,0,0-.049.445,4.053,4.053,0,0,0,.525,1.489C18.726,12.432,18.839,12.621,18.934,12.773Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.605,18.315a6.587,6.587,0,0,0,4.466-1.4h0c-.047-.3.36-.84.247-1.29-.039-.155-.392-.38-.606-.614a15.006,15.006,0,0,1-2.543-3.486c-.053-.123-.085-.8-.452-.53-.044,1.642,1.176,3,2.086,4.1.444.535.98.841.487,1.673-.8.3-2.083,1.169-3.189.979-.379-.065-.458-.365-.523-.668a2.376,2.376,0,0,0-.1-.363.719.719,0,0,0-.046-.1A1.322,1.322,0,0,0,20.605,18.315Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6,14.1a.832.832,0,0,0-.159.111,1.221,1.221,0,0,0-.37.781.8.8,0,0,0,.125-.109c.153-.156.313-.357.6-.217a2.291,2.291,0,0,0,.19,2.213c0-.733-.117-1.987.509-1.95.438.027.527.964.9,1.177A1.719,1.719,0,0,0,8.378,14.07.979.979,0,0,0,7.6,14.1Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.868,18.875a4.016,4.016,0,0,0,0,1.063,3.425,3.425,0,0,0,2.962-2.249h0A8.538,8.538,0,0,1,22.868,18.875Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.47,20a4.933,4.933,0,0,0-.077-1.066,10.285,10.285,0,0,1-4.35-.562C18.518,19.644,20.659,20.092,22.47,20Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.846,19.39h0c-.915,0-.143.51.012.709a4.687,4.687,0,0,0,1.284,1.428,5.27,5.27,0,0,0,3.426.014,1.111,1.111,0,0,0,.536-.609C21.026,20.982,18.563,21.189,17.846,19.39Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96,29.28a1.709,1.709,0,0,0-1.042-.753,1.433,1.433,0,0,0-.918.12c-.008.2-.018.415-.031.632Z",
    style: {
      fill: "#81b0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.971,24.749c-.686.061-1.493.373-2.252.419-.069,0-.138.006-.206.006s-.136,0-.2-.01a1.93,1.93,0,0,1-.392-.076,1.666,1.666,0,0,1-.188-.07c0,.052-.071.033-.082.076.085.066.167.126.247.179s.159.1.238.143a2.218,2.218,0,0,0,.475.19,3.052,3.052,0,0,0,.816.09c.1,0,.212,0,.327-.009C21.169,25.384,21.537,25.031,21.971,24.749Z",
    style: {
      fill: "#f0d6b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.086,29.048l-.351.233h.527Q19.176,29.162,19.086,29.048Z",
    style: {
      fill: "#81b0c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.681,29.769v-.335a.153.153,0,0,1,.153-.153h.283a20.236,20.236,0,0,0-.81-2.026,24.079,24.079,0,0,1,5.61-3.485c.118-.047.811.809,1.2,1.257a2.353,2.353,0,0,0,.24.257,21.079,21.079,0,0,0,3.087,1.655,12.164,12.164,0,0,0,.476,1.948c.039.126.078.26.118.394H15.2a.153.153,0,0,1,.153.153v.158h.139a.153.153,0,0,1,.153.153V30h1.691v-.255a.153.153,0,0,1,.153-.153h.78v-.158a.153.153,0,0,1,.153-.153h.317l.351-.233q.09.114.176.233h.843a6.313,6.313,0,0,0-.489-.685c.115-.122.217-.256.33-.381.492.206.812-.27,1.19-.229.433.046.776.644,1.394.605-.014.22-.024.44-.034.66v.03h.474c.012-.217.023-.429.031-.632a1.433,1.433,0,0,1,.918-.12,1.709,1.709,0,0,1,1.042.753h.481c.034-.06.069-.119.1-.179-.143-.335-.495-.477-.6-.85a5.123,5.123,0,0,0-.13-3.9.932.932,0,0,0-.686-.51.948.948,0,0,0-.514.106,1.457,1.457,0,0,1,.275-.283,4.391,4.391,0,0,0,.869-.776c.712.573,1.141,1.112,1.824,1.725.37.332,1.1.73,1.172,1.266a2.339,2.339,0,0,1-.054.614c-.051.281-.12.575-.156.756A20.836,20.836,0,0,1,27,29.307a.15.15,0,0,1,.072.127V30h.368c.258-.808.511-1.635.766-2.489a6.207,6.207,0,0,0,.478-2.187c-.078-.617-1.04-1.265-1.547-1.754-.281-.271-1.593-1.267-1.669-1.64s.535-1.178.731-1.586a11.669,11.669,0,0,0,.621-1.788c1.032-3.627,1.137-8.611-.339-11.592a12.54,12.54,0,0,0-3.1-3.428c-2.3-1.742-6.563-1.935-9.339-.913a13.481,13.481,0,0,0-2.2.939C10.024,4.628,8.094,5.342,7.555,7.49c-1.328.6-1.729,2.3-1.662,4.268a6.221,6.221,0,0,1,.149,1.227c-.037.184-.286.419-.336.538a5.3,5.3,0,0,0,.609,4.592A3.225,3.225,0,0,0,8.468,19.5a4.568,4.568,0,0,0,.447,1.672c.17.373.805,1.043.571,1.519a6.987,6.987,0,0,1-1.495.966c-1.158.695-2,1.12-3.066,1.89-.692.5-1.773.562-1.6,1.71a17.869,17.869,0,0,0,.808,2.513c.025.078.053.155.08.232h.47ZM13.032,4.355a1.647,1.647,0,0,1-.159.166,11.333,11.333,0,0,0-.941.776c-.373.413-.79,1.521-1.285,1.644A3.817,3.817,0,0,1,9.9,6.912,2.125,2.125,0,0,0,9.433,7a7.389,7.389,0,0,1-1.084.325c.748-1.635,3.08-2.957,4.9-3.473.1-.028.188.04.271.129C13.509,4.268,13.224,4.262,13.032,4.355Zm-2.385,3.7c.3,1.521-.561,3.254-.192,4.861.125.546.56,1.394-.134,1.413a2.147,2.147,0,0,0-3.145-1.747,2.321,2.321,0,0,0-.218.12c-.1-1.179-.266-2.836.538-3.721a4.409,4.409,0,0,1,3.009-1.419A2.81,2.81,0,0,1,10.647,8.059ZM7.254,17.8A3.858,3.858,0,0,1,6.232,15.2a2.034,2.034,0,0,1,2.2-1.963c.684.075,1.014.674,1.208,1.338.054.187.1.379.136.566.505.027,1.235-.022,1.474-.416-.034-.962-.481-1.733-.45-2.617a14.085,14.085,0,0,1,.388-2.263,4.109,4.109,0,0,0-.123-2.532c.747-1.695,2.939-3.032,4.56-3.841,2.009-1,5.207-.2,7.1.866a4.127,4.127,0,0,1,.49.329,8.674,8.674,0,0,1,1.479,1.563c.234.3.459.6.681.889-.967-.287-1.8.132-1.832.866a1.07,1.07,0,0,0,.016.246c.9-.821,2.427-.009,2.88.9a9.567,9.567,0,0,1,.5,3.446,14.242,14.242,0,0,1-2.145,8.621,6.258,6.258,0,0,1-1.365,1.68c-1.425,1-3.591,1.908-5.446,1.286-2.451-.823-3.565-2.456-4.913-4.326a4.466,4.466,0,0,0,1.472,2.656,6.648,6.648,0,0,0,2.176,1.778c-.673-.158-1.7-.208-1.985.4a15.465,15.465,0,0,1-1.549-.162,3.181,3.181,0,0,1-2.22-1.166,11.351,11.351,0,0,1-1.445-3.365,3.837,3.837,0,0,1-.125-.832c.088-.478.939-.687.6-1.355-.618-.006-.757.562-1.324.618A1.734,1.734,0,0,1,7.254,17.8Zm12.77,9.38-.031-.131c-.02-.083-.036-.159-.048-.238a1.7,1.7,0,0,1-.007-.412,1.009,1.009,0,0,1,.582-.2.7.7,0,1,1-.428,1.31c-.021-.121-.043-.221-.064-.31Zm-7.782-2.419a6.738,6.738,0,0,0,2.269.4,1.748,1.748,0,0,1-.112.6,1.233,1.233,0,0,0-.041.3,4.237,4.237,0,0,1-2.1-.882A.282.282,0,0,1,12.242,24.766Zm7.367.839a2.218,2.218,0,0,1-.475-.19c-.078-.042-.157-.09-.238-.143s-.162-.113-.247-.179c.011-.043.079-.024.082-.076a1.666,1.666,0,0,0,.188.07,1.93,1.93,0,0,0,.392.076c.067.006.134.009.2.01s.137,0,.206-.006c.759-.046,1.566-.358,2.252-.419-.433.283-.8.636-1.218.938-.115.006-.224.009-.327.009A3.052,3.052,0,0,1,19.609,25.605Zm-1.872,3.706a4.834,4.834,0,0,1-1.833.559c-.158-.037-.2-.2-.253-.385-.013-.046-.026-.092-.042-.139s-.03-.085-.047-.128a6.585,6.585,0,0,1-.544-1.9c0-.088-.009-.182-.013-.28-.039-.944-.031-2.225.89-2.049a9.077,9.077,0,0,1,2.408.881c.194.106.347.225.525.322a1.585,1.585,0,0,0,.294.127,1.565,1.565,0,0,0,.177.044,1.883,1.883,0,0,0,.2.027c0,.078-.006.157-.009.236a3.285,3.285,0,0,1-.906.281,1.555,1.555,0,0,0-.291.106,3.5,3.5,0,0,1,.371.036,3.039,3.039,0,0,1,.916.29l0,.063q-.01.264-.021.527A21.007,21.007,0,0,1,17.737,29.311Zm4.245-1.536q-.164-.039-.322-.084a8.618,8.618,0,0,1,.035-.9.7.7,0,0,1,.2-.095,4.209,4.209,0,0,1,.757-.1,1.463,1.463,0,0,0-.243-.092c-.043-.012-.088-.023-.133-.032A1.761,1.761,0,0,0,22,26.429a1.475,1.475,0,0,0-.407.038,1.694,1.694,0,0,0-.175-.558l.057-.023c.609-.268,1.918-1.529,2.665-1.093a1.125,1.125,0,0,1,.348.652,7.057,7.057,0,0,1,.2,1.378,2.963,2.963,0,0,1-.073.87,1.081,1.081,0,0,1-.172.381h0A12.138,12.138,0,0,1,21.982,27.774Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53,18.862c-.616-.3-1.056-.135-1.136-.028-.152.2.163,1.306.163,1.306l.3.061C16.8,18.984,17.53,18.862,17.53,18.862Z",
    style: {
      fill: "#f7e4cd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.393,28.961a.334.334,0,0,0-.333.319h.666A.334.334,0,0,0,21.393,28.961Z",
    style: {
      fill: "#1d1919"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.642,29.745a.153.153,0,0,0-.153-.153h-.139v.177a.153.153,0,0,1-.153.153H4.834a.153.153,0,0,1-.153-.153V30H15.642Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.918,29.922h-8.5a.153.153,0,0,1-.153-.153v-.177h-.78a.153.153,0,0,0-.153.153V30h9.737v-.231A.153.153,0,0,1,26.918,29.922Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.834,29.922H15.2a.153.153,0,0,0,.153-.153v-.335a.153.153,0,0,0-.153-.153H4.834a.153.153,0,0,0-.153.153v.335A.153.153,0,0,0,4.834,29.922Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.266,29.769a.153.153,0,0,0,.153.153h8.5a.153.153,0,0,0,.153-.153v-.335A.15.15,0,0,0,27,29.307a.149.149,0,0,0-.081-.026h-8.5a.153.153,0,0,0-.153.153v.335Z",
    style: {
      fill: "#231f20"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJenkinsSvgrepoCom);
export default __webpack_public_path__ + "static/media/jenkins-svgrepo-com.6372ba9be08ac53a61ba8cd8a927a4d4.svg";
export { ForwardRef as ReactComponent };